import React, { useEffect, useState } from "react";
import { Radio, Volume2, Sparkles } from "lucide-react";
import { api } from "../../lib/api";
import { D, inputStyle, Btn } from "./ui";

// Karakter penyiar radio (Kak Gita): profil role/persona, dengar contoh suara (suara = Pengumuman Suara AI), tulis & siarkan pengumuman dari topik.
export function PenyiarRadio({ token, setMsg, reload }) {
  const [p, setP] = useState(null);
  const [topik, setTopik] = useState("");
  const [sibuk, setSibuk] = useState("");
  const [hasil, setHasil] = useState(null);
  useEffect(() => { api.getPenyiar(token).then(setP).catch(e => setMsg(e.message)); }, [token]); // eslint-disable-line
  if (!p) return null;
  const k = p.penyiar;
  async function uji() { setSibuk("uji"); try { const r = await api.ujiPenyiar(token); setHasil({ url: r.url, teks: p.contoh_siaran }); } catch (e) { setMsg(e.message); } setSibuk(""); }
  async function siar() {
    if (!topik.trim()) return; setSibuk("siar");
    try { const r = await api.siaranPenyiar(token, { topik, simpan: true }); setHasil({ url: r.url, teks: r.pengumuman.text }); setTopik(""); reload?.(); setMsg(`Siaran "${r.pengumuman.title}" masuk daftar pengumuman (aktif)`); }
    catch (e) { setMsg(e.message); }
    setSibuk("");
  }
  return (
    <div data-testid="penyiar-radio" style={{ background: D.cream, borderRadius: 20, padding: 16, marginBottom: 12 }}>
      <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
        <div style={{ width: 56, height: 56, borderRadius: 18, background: D.blue, display: "grid", placeItems: "center", color: "#fff", flex: "none" }}><Radio size={26} /></div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1.4, color: D.sub, textTransform: "uppercase" }}>Penyiar Jawsel FM 57.58</div>
          <div data-testid="penyiar-nama" style={{ fontSize: 22, fontWeight: 800, color: D.ink }}>{k.nama} <span style={{ fontSize: 13, fontWeight: 600, color: D.sub }}>({k.nama_lengkap})</span></div>
          <div style={{ fontSize: 12.5, color: D.sub, marginTop: 2 }}>{k.jabatan}</div>
        </div>
      </div>
      <div style={{ display: "grid", gap: 10, marginTop: 14, fontSize: 13, color: D.ink, lineHeight: 1.5 }}>
        <div><b>Role.</b> {k.role}</div>
        <div><b>Persona.</b> {k.persona}</div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>{k.catchphrase.map(c => <span key={c} style={{ background: D.blueSoft, color: D.blue, padding: "4px 10px", borderRadius: 999, fontSize: 12, fontWeight: 700 }}>“{c}”</span>)}</div>
        <div data-testid="penyiar-suara" style={{ fontSize: 12, color: D.sub }}>Suara: mengikuti <b>Pengumuman Suara AI</b> ({p.suara.sumber} · {p.suara.voice}). Ganti suaranya di panel itu.</div>
        <div data-testid="penyiar-bgm" style={{ fontSize: 12, color: D.sub }}>BGM: musik latar otomatis ala radio — intro mengembang, mengecil saat Kak Gita bicara, naik di jeda, outro memudar. Mood: <b>ceria</b> (siang) · <b>hangat</b> (malam & manual) · <b>ninabobo</b> (dongeng).</div>
      </div>
      <div style={{ display: "flex", gap: 8, marginTop: 14, alignItems: "stretch", flexWrap: "wrap" }}>
        <input data-testid="penyiar-topik" value={topik} onChange={e => setTopik(e.target.value)} placeholder="Topik siaran, mis. jadwal pesawat berikutnya & sambutan warga baru" style={{ ...inputStyle, flex: 1, minWidth: 220, background: "#fff" }} />
        <Btn testid="penyiar-siar" onClick={siar} disabled={sibuk !== "" || !topik.trim()}><Sparkles size={14} /> {sibuk === "siar" ? "Kak Gita menulis…" : "Tulis & siarkan"}</Btn>
        <Btn testid="penyiar-uji" variant="ghost" onClick={uji} disabled={sibuk !== ""}><Volume2 size={14} /> {sibuk === "uji" ? "Membuat…" : "Dengar contoh"}</Btn>
      </div>
      {hasil && (
        <div data-testid="penyiar-hasil" style={{ marginTop: 12, background: "#fff", borderRadius: 16, padding: 14 }}>
          <audio controls autoPlay src={`${process.env.REACT_APP_BACKEND_URL}${hasil.url}`} style={{ width: "100%" }} />
          <div style={{ fontSize: 13, color: D.ink, marginTop: 8, whiteSpace: "pre-wrap", lineHeight: 1.5 }}>{hasil.teks}</div>
        </div>
      )}
    </div>
  );
}
